module.exports = __webpack_public_path__ + "img/LogoAR-02.36e528a6.svg";